import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { filter, findIndex, forEach, set } from 'lodash'

import { LabelingState } from '@/stores/slices/Labeling/types'
import { addTag, addTagsToImages, deleteTag } from '@/stores/slices/Labeling/thunks/clsTag'
import { updateLabelingItemStatus } from '@/stores/slices/Labeling/reducers/common'
import { LABELING_STATUS } from '@/api/LabelingNode/const'

export const clsTagExtraReducers = (builder: ActionReducerMapBuilder<LabelingState>) => {
  builder.addCase(addTag.fulfilled, (state, action) => {
    const updatedIndex = findIndex(state.files, (f) => f?._id === action.payload._id)
    set(state.files, `[${[updatedIndex]}].labelingObjects`, action.payload.labelingObjects)
  })
  builder.addCase(deleteTag.fulfilled, (state, action) => {
    const { _id, labelingItemId } = action.payload

    const updatedIndex = findIndex(state.files, (f) => f?._id === labelingItemId)
    set(state.files, `[${[updatedIndex]}].labelingObjects`, filter(state.files[updatedIndex]?.labelingObjects, (o) => o._id !== _id))
  })
  builder.addCase(addTagsToImages.fulfilled, (state, action) => {
    const { taggedItems, finishAllTaggedItems } = action.meta.arg

    if (finishAllTaggedItems) {
      const { isReviewAvailable } = state
      // 검수 있으면 FINISHED, 없으면 COMPLETED
      const updatedStatus = isReviewAvailable ? LABELING_STATUS.FINISHED : LABELING_STATUS.COMPLETED

      forEach(taggedItems, (item) => {
        updateLabelingItemStatus(state, {
          itemId: item.labelingItemId,
          updatedStatus,
        })
      })
    }
  })
}
